import React from 'react';
import RequestFormComponent, { Props } from '@websky/core/src/Refund/Components/RequestForm/RequestForm';

const RequestForm: React.FC<Props> = props => {
	return <RequestFormComponent {...props} isRulesOptional={true} />;
};

export default RequestForm;
